import React, { useEffect, useState } from 'react';
import ApiRequest from '../Common/restservice';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

function Passbook() {
    const navigate = useNavigate();
    const [fromDate, setFromDate] = useState(moment().subtract(10, 'days').format('YYYY/MM/DD'));
    const [toDate, setToDate] = useState(moment().format('YYYY/MM/DD'));
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        GetTransactions();
    }, [])
    const GetTransactions = async () => {
        let jsoninput = {
            fromdate: fromDate,
            todate: toDate
        }
        let url = "GetCashWallet.asp";
        let res = await ApiRequest(url, "POST", jsoninput, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            setTableData([]);
            return;
        }
        setTableData(res.items);
    }
    return (
        <section className="content">
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                Passbook
                            </h3>
                        </div>

                        <div className="card-body">
                            <div className="d-md-flex mt-4 mb-2">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <span className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="fa fa-calendar"></i>
                                                </span>
                                            </span>
                                            <input type="date" className="form-control daterange-single" id="start_date" name="start_date" placeholder="From Date" autoComplete="off" onChange={(e) => {
                                                setFromDate(e.target.value)
                                            }} value={fromDate} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <span className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="fa fa-calendar"></i>
                                                </span>
                                            </span>
                                            <input type="date" className="form-control daterange-single" id="end_date" name="end_date" placeholder="To Date" autoComplete="off" onChange={(e) => {
                                                setToDate(e.target.value)
                                            }} value={toDate} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 text-left">
                                    <div className="form-group"><button type="button" className="btn btn-primary" onClick={(e) => GetTransactions()}> Search </button></div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Description</th>
                                            <th>Debit</th>
                                            <th>Credit</th>
                                            <th>Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            tableData.length <= 0 ? <tr>
                                                <td colSpan="6">No Details Found</td>
                                            </tr> :
                                                tableData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(index + 1)}</td>
                                                        <td>{item.date}</td>
                                                        <td>{item.Description}</td>
                                                        <td>{item.Debit}</td>
                                                        <td>{item.Credit}</td>
                                                        <td>{item.Balance}</td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Passbook
